
import { Options, Vue } from 'vue-class-component';
import Partners from '@/components/Partners.vue';
import Logo from "@/base-components/Logo.vue";

@Options({
  components: {
    Partners,
    Logo
  },
})
export default class PartnersView extends Vue {}
